import { render, staticRenderFns } from "./DigitalMarketingConfig.vue?vue&type=template&id=15556c43"
import script from "./DigitalMarketingConfig.vue?vue&type=script&lang=js"
export * from "./DigitalMarketingConfig.vue?vue&type=script&lang=js"
import style0 from "./DigitalMarketingConfig.vue?vue&type=style&index=0&id=15556c43&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports